<div>
  <app-kf-registration-admin-filters
    [showStatus]="view === 'all'"
    (search)="searchKfRegistration($event)">
  </app-kf-registration-admin-filters>
  <mat-divider></mat-divider>
  <app-kf-registration-admin-table *ngIf="kfRegistrationPage"
                                   [page]="kfRegistrationPage.number"
                                   [pageSize]="kfRegistrationPage.size"
                                   [totalElements]="kfRegistrationPage.totalElements"
                                   [list]="kfRegistrationPage.content"
                                   (loadKfRegistrations)="loadKfRegistration($event)">
  </app-kf-registration-admin-table>
</div>
